import axios from 'axios'

export const isAuthenticationError = (error: unknown): boolean => {
  if (!axios.isAxiosError(error)) {
    return false
  }

  return [401, 403, 419].includes(error.response?.status ?? 0)
}
